import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useExamHeaderStyles = makeStyles(() => ({
    topNavBar: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e0e0",
        padding: "0.4rem 0.2rem",
        gap: "2px",
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        "& .MuiButtonBase-root": {
            padding: "2px 0px !important",
            "@media (max-width:599px)": {
                padding: "0px !important",
            }
        },
    },
    subjectWrapper: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e0e0",
        gap: theme.spacing(0.5),
        position: "relative",
        scrollBehavior: "smooth",
        overflowX: "auto",
        flex: 1, // Allow it to take available space
        minWidth: 0, // Critical for flex child overflow
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    activeSubjectButton: {
        backgroundColor: "#38aae9 !important",
        color: "white !important",
        textTransform: "none !important",
        display: "flex !important",
        alignItems: "center !important",
        gap: `${theme.spacing(1)} !important`,
        whiteSpace: "nowrap !important",
        flexShrink: "0",
        "@media (max-width:599px)": {
            fontSize: "0.68rem !important",
            padding: "2px 8px !important",
            minHeight: "24px !important",
        }
    },
    inactiveSubjectButton: {
        backgroundColor: "#cfcfcf !important",
        color: "black !important",
        textTransform: "none !important",
        display: "flex !important",
        alignItems: "center !important",
        gap: `${theme.spacing(1)} !important`,
        whiteSpace: "nowrap !important",
        flexShrink: "0",
        "@media (max-width:599px)": {
            fontSize: "0.68rem !important",
            padding: "2px 8px !important",
            minHeight: "24px !important",
        }
    },
    sectionTimeContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
        borderBottom: "1px solid #ddd",
        backgroundColor: "white",
        "@media (max-width:599px)": {
            padding: "2px 8px",
            "& .MuiTypography-root": {
                fontSize: "0.6rem",
            }
        }
    },
    wFull: {
        width: "calc(100vw - 90px)",
    },
    wHaf: {
        width: "calc(100vw - 395px)",
    },
    sectionTabsContainer: {
        display: "flex",
        overflowX: "auto",
        scrollBehavior: "smooth",
        gap: "2px",
        marginLeft: "5px",
        justifyContent: "flex-start", // Left align tabs
        "&::-webkit-scrollbar": {
            display: "none",
        },
        "@media (max-width:599px)": {
            margin: "0px 2px",
        }
    },
    activeSectionTab: {
        backgroundColor: "#4787c2 !important",
        color: "white !important",
        borderRadius: "0 !important",
        textTransform: "none !important",
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        gap: `${theme.spacing(1)} !important`,
        whiteSpace: "nowrap !important",
        flexShrink: "0",
        textWrap: "nowrap",
        "@media (max-width:599px)": {
            fontSize: "0.65rem !important",
            padding: "2px 8px !important",
            minHeight: "22px !important",
        }
    },
    inactiveSectionTab: {
        backgroundColor: "#cfcfcf !important",
        color: "black !important",
        borderRadius: "0 !important",
        textWrap: "nowrap",
        textTransform: "none !important",
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        gap: `${theme.spacing(1)} !important`,
        whiteSpace: "nowrap !important",
        flexShrink: "0",
        "@media (max-width:599px)": {
            fontSize: "0.65rem !important",
            padding: "2px 8px !important",
            minHeight: "22px !important",
        }
    },
   questionDetailsContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
        flexWrap: "wrap",
        backgroundColor: "white",
        borderTop: "1px solid #ddd",
        borderBottom: "1px solid #ddd",
        "@media (max-width:599px)": {
            padding: "2px 8px",
            "& .MuiTypography-root": {
                fontSize: "0.62rem",
            }
        }
    },
    calculatorIcon: {
        color: "orange !important",
    },
    positiveMark: {
        color: "green",
    },
    negativeMark: {
        color: "red",
    },
    timeLeft: {
        color: "green",
    },
    arrowBtn: {
        background: "#cccccc !important",
        borderRadius: "0 !important",
        padding: "4px 8px !important",
        color: "#505041 !important",
        "@media (max-width:599px)": {
            padding: "2px 4px !important",
        },
        "&:hover": {
            backgroundColor: "#bbbbbb !important",
        },
    },
}));

export default useExamHeaderStyles;
